/* eslint-disable */

import React from "react";
import { useTranslation } from "react-i18next";

export default function servicePageActivation() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  
  return (
    <div className="min-h-max h-fit w-full" dir={isRTL ? "rtl" : "ltr"}>
      <section className="relative w-full px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
              {t("servicePageActivation.orderMessagesCustomization.title")}
              <span className="text-[#9e68ba] dark:text-purple-400"> {t("servicePageActivation.orderMessagesCustomization.subtitle")} </span>
            </h3>
            
            <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
              {t("servicePageActivation.orderMessagesCustomization.description")}
            </p>

            {/* Variables disponibles */}
            <div className="bg-[#fcf6ff] dark:!bg-purple-900/20 p-4 rounded-lg border border-[#fbf4ff] dark:!border-purple-800/30 mb-6">
              <h4 className="font-medium text-[#9e68ba] dark:text-purple-300 mb-3">
                {t("servicePageActivation.orderMessagesCustomization.variables.title")}
              </h4>
              <p className="text-gray-700 dark:text-gray-300 mb-3">
                {t("servicePageActivation.orderMessagesCustomization.variables.description")}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="bg-gray-50 dark:!bg-gray-800 p-3 rounded">
                  <code className="text-sm text-purple-600 dark:text-purple-400 font-mono">
                    {"{order?.name}"}
                  </code>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {t("servicePageActivation.orderMessagesCustomization.variables.items.name")}
                  </p>
                </div>
                <div className="bg-gray-50 dark:!bg-gray-800 p-3 rounded">
                  <code className="text-sm text-purple-600 dark:text-purple-400 font-mono">
                    {"{order?.nameproduct}"}
                  </code>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {t("servicePageActivation.orderMessagesCustomization.variables.items.product")}
                  </p>
                </div>
                <div className="bg-gray-50 dark:!bg-gray-800 p-3 rounded">
                  <code className="text-sm text-purple-600 dark:text-purple-400 font-mono">
                    {"{order?.total}"}
                  </code>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {t("servicePageActivation.orderMessagesCustomization.variables.items.total")}
                  </p>
                </div>
                <div className="bg-gray-50 dark:!bg-gray-800 p-3 rounded">
                  <code className="text-sm text-purple-600 dark:text-purple-400 font-mono">
                    {"{store.currencySymbol}"}
                  </code>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {t("servicePageActivation.orderMessagesCustomization.variables.items.currency")}
                  </p>
                </div>
              </div>
            </div>

            {/* Statuts disponibles */}
            <div className="bg-blue-50 dark:!bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:!border-blue-800/30 mb-6">
              <h4 className="font-medium text-blue-800 dark:text-blue-300 mb-3">
                {t("servicePageActivation.orderMessagesCustomization.statuses.title")}
              </h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between bg-white dark:!bg-gray-800 p-3 rounded">
                  <div>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.3.title")}
                    </span>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.3.description")}
                    </p>
                  </div>
                  <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded dark:!bg-green-900 dark:text-green-300">
                    ID: 3
                  </span>
                </div>
                
                <div className="flex items-center justify-between bg-white dark:!bg-gray-800 p-3 rounded">
                  <div>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.4.title")}
                    </span>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.4.description")}
                    </p>
                  </div>
                  <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded dark:!bg-blue-900 dark:text-blue-300">
                    ID: 4
                  </span>
                </div>
                
                <div className="flex items-center justify-between bg-white dark:!bg-gray-800 p-3 rounded">
                  <div>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.6.title")}
                    </span>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.6.description")}
                    </p>
                  </div>
                  <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded dark:!bg-red-900 dark:text-red-300">
                    ID: 6
                  </span>
                </div>
                
                <div className="flex items-center justify-between bg-white dark:!bg-gray-800 p-3 rounded">
                  <div>
                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.11_1.title")}
                    </span>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {t("servicePageActivation.orderMessagesCustomization.statuses.items.11_1.description")}
                    </p>
                  </div>
                  <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded dark:!bg-yellow-900 dark:text-yellow-300">
                    ID: 11-1
                  </span>
                </div>
              </div>
            </div>

            {/* كيفية العمل */}
            <div className="bg-gray-50 dark:!bg-gray-800/50 p-5 rounded-lg border border-gray-200 dark:!border-gray-700 mb-6">
              <h4 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                {t("servicePageActivation.orderMessagesCustomization.howItWorks.title")}
              </h4>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-purple-100 dark:!bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    1
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.0.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.0.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-purple-100 dark:!bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    2
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.1.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.1.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-purple-100 dark:!bg-purple-900/30 text-purple-800 dark:text-purple-300 rounded-full w-6 h-6 flex items-center justify-center ml-3 flex-shrink-0 text-sm font-bold">
                    3
                  </div>
                  <div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.2.title")}
                    </h5>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      {t("servicePageActivation.orderMessagesCustomization.howItWorks.steps.2.description")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* الفوائد */}
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {/* فوائد تجربة العميل */}
              <div className="bg-green-50 dark:!bg-green-900/20 p-4 rounded-lg border border-green-100 dark:!border-green-800/30">
                <h4 className="font-semibold text-green-800 dark:text-green-300 mb-3">
                  {t("servicePageActivation.orderMessagesCustomization.benefits.customerExperience.title")}
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.customerExperience.items.0")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.customerExperience.items.1")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 dark:text-green-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.customerExperience.items.2")}
                  </li>
                </ul>
              </div>

              {/* فوائد التشغيل */}
              <div className="bg-blue-50 dark:!bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:!border-blue-800/30">
                <h4 className="font-semibold text-blue-800 dark:text-blue-300 mb-3">
                  {t("servicePageActivation.orderMessagesCustomization.benefits.operations.title")}
                </h4>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.operations.items.0")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.operations.items.1")}
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                    {t("servicePageActivation.orderMessagesCustomization.benefits.operations.items.2")}
                  </li>
                </ul>
              </div>
            </div>

            {/* حالات الاستخدام */}
            <div className="mb-8">
              <h4 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                {t("servicePageActivation.orderMessagesCustomization.useCases.title")}
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Case 1 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-purple-500 dark:!bg-purple-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.useCases.cases.0.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.orderMessagesCustomization.useCases.cases.0.description")}
                  </p>
                </div>

                {/* Case 2 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-blue-500 dark:!bg-blue-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.useCases.cases.1.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.orderMessagesCustomization.useCases.cases.1.description")}
                  </p>
                </div>

                {/* Case 3 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-green-500 dark:!bg-green-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.useCases.cases.2.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.orderMessagesCustomization.useCases.cases.2.description")}
                  </p>
                </div>

                {/* Case 4 */}
                <div className="bg-white dark:!bg-gray-800 p-3 rounded-lg border border-gray-200 dark:!border-gray-700 shadow-sm dark:shadow-gray-900/50">
                  <div className="flex items-center mb-2">
                    <div className="w-3 h-3 bg-orange-500 dark:!bg-orange-400 rounded-full ml-2"></div>
                    <h5 className="font-medium text-gray-800 dark:text-gray-200">
                      {t("servicePageActivation.orderMessagesCustomization.useCases.cases.3.title")}
                    </h5>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.orderMessagesCustomization.useCases.cases.3.description")}
                  </p>
                </div>
              </div>
            </div>

            {/* نصائح للكتابة */}
            <div className="bg-yellow-50 dark:!bg-yellow-900/20 border border-yellow-200 dark:!border-yellow-800/30 rounded-lg p-4">
              <h4 className="font-semibold text-yellow-800 dark:text-yellow-300 mb-3">
                {t("servicePageActivation.orderMessagesCustomization.writingTips.title")}
              </h4>
              <ul className="text-sm text-yellow-700 dark:text-yellow-300 space-y-2">
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.orderMessagesCustomization.writingTips.items.0")}
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.orderMessagesCustomization.writingTips.items.1")}
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.orderMessagesCustomization.writingTips.items.2")}
                </li>
                <li className="flex items-start">
                  <span className="ml-2 text-yellow-600 dark:text-yellow-400">•</span>
                  {t("servicePageActivation.orderMessagesCustomization.writingTips.items.3")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}